import axios from "axios";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Price } from "../../components/__simple/_price"
import config from "../../configuration/config";
import i18n from "i18next";
import { LoadingOutlined } from '@ant-design/icons';
function CarUser({
    id,
    img,
    name = "",
    brand,
    brandIcon,
    brandImage,
    link,
    inputDate,
    onUpdate,
    minPrice,
    fromToYear,
    userCarName,
    showDetails = true,
    withMoreLinke = true,
    fetchType,
    SN,
    active = false,
    onclick,
    topCardClassName = "",
    isLoadingUpdateSN
}) {
    const { t: trans } = useTranslation(["common", "info"]);

    const handleRemoveUserCar = () => {
        if (window.confirm('هل ترغب بحذف المركبة الحالة؟')) {
            try {
                axios.put(
                    `${config.controllURL}${i18n.language || 'ar'}/api/Pages/UpdatesiteUserCars`,
                    {
                        "Values": {
                            "IsDelete": true
                        },
                        "Filters": `where GUID = '${id}'`
                    }
                ).then(response => {
                    window.location.reload();
                }).catch(error => {
                    console.log(error);
                })
            } catch (err) {
                console.log('error in deleting the vehicle', err);
            }
        }
    };
    return (
        <div className={`vc rv ${(active ? "on" : "")} ${topCardClassName}`}>
            <div className="vc-img nice-pointer" onClick={(e) => {
                if (!withMoreLinke) {
                    e.preventDefault();
                    if (onclick) onclick();
                }
            }}>
                {fromToYear && <span className="vc-type">{fromToYear}</span>}
                <Link to={link || '#'} onClick={(e) => {
                    if (!withMoreLinke) {
                        e.preventDefault();
                        if (onclick) onclick();
                    }
                }}>
                    <img src={config.FilePathURL + img} alt={name || ""} onError={e => e.target.style.display = 'none'} />
                </Link>
            </div>

            <div className="vc-body">
                <div className="vc-name text-line-clamp text-line-clamp-2" style={{ maxWidth: "100%" }}>
                    <Link to={link || '#'} style={{ color: "inherit" }} onClick={(e) => {
                        if (!withMoreLinke) {
                            e.preventDefault();
                            if (onclick) onclick();
                        }
                    }}>
                        {name} {userCarName && <span className="text-gray" style={{ fontWeight: 400 }}>{` (${userCarName}) `}</span>}
                    </Link>
                </div>

                {brand && <div className="vc-sub">{brand}</div>}

                {inputDate && <div className="vc-sub" style={{ marginBottom: "5px" }}>
                    {trans("info:input_date")}: <strong>{inputDate}</strong>
                </div>}

                <div className="vc-foot">
                    {minPrice ? (
                        <div className="vc-price">
                            <Price price={minPrice} />
                        </div>
                    ) : <div></div>}

                    {showDetails && (
                        <div className="flex gap-2">
                            {id && (
                                <button className="vc-go" title="حذف" style={{ background: "#fee2e2", cursor: "pointer" }} onClick={(e) => {
                                    e.preventDefault();
                                    handleRemoveUserCar(id);
                                }}>
                                    <svg viewBox="0 0 24 24" style={{ stroke: "#ef4444", width: "16px", height: "16px", fill: "none", strokeWidth: 2 }}>
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                        <line x1="10" y1="11" x2="10" y2="17"></line>
                                        <line x1="14" y1="11" x2="14" y2="17"></line>
                                    </svg>
                                </button>
                            )}

                            {SN && (
                                <button className="vc-go" title="تعديل" style={{ cursor: "pointer" }} onClick={(e) => {
                                    e.preventDefault();
                                    if (onUpdate) onUpdate(id, SN, fetchType);
                                }}>
                                    {(isLoadingUpdateSN == SN) ? <LoadingOutlined /> : (
                                        <svg viewBox="0 0 24 24" style={{ stroke: "var(--g)", width: "16px", height: "16px", fill: "none", strokeWidth: 2.5 }}>
                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                        </svg>
                                    )}
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>

    );
}

export default CarUser;